import { render, staticRenderFns } from "./AccountSettingBanking.vue?vue&type=template&id=c6a6b3ea&scoped=true"
import script from "./AccountSettingBanking.vue?vue&type=script&lang=js"
export * from "./AccountSettingBanking.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingBanking.vue?vue&type=style&index=0&id=c6a6b3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a6b3ea",
  null
  
)

export default component.exports